import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { ProjectBudget } from "@/types/gear";

export function useBudgetStatus(projectId: string, enabled: boolean = true) {
  return useQuery({
    queryKey: ["budget-status", projectId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("project_budget_status")
        .select("*")
        .eq("id", projectId)
        .single();

      if (error) {
        toast.error("Failed to load budget status");
        throw error;
      }

      return data as ProjectBudget;
    },
    enabled,
  });
}